import { TP_Building } from './types'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { LoadingView } from "../../../../components"
import { SmallPanel as EnergyPanel } from '../../../Utils/EnergyOverview'
import { useStyletron } from 'baseui';
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react'
import { schema as evoSchema } from '../../../Utils/EnergyOverview'
import { getAddress, hasAddress } from '../../../Spaces/Address/utils';
import LocationView from './LocationView';
import { ActiveHeatingGenerators } from '../../Heatings/P_HeatingGenerator';
import { ActiveCoolingGenerators } from '../../Coolings/P_CoolingGenerator';
import { ActiveHeatingOutlets } from '../../Heatings/P_HeatingOutlet';
import { ActiveCoolingOutlets } from '../../Coolings/P_CoolingOutlet';
import { ActiveHeatingPuffer } from '../../Heatings/P_HeatingPuffer';
import { ActiveAirHandlingUnits } from '../../AirHandlingUnits/P_AirHandlingUnit';
import ActiveLightsPanel from '../../../Devices/Light/ActiveLightsPanel';
import Icon from './Icon';
import { ImportantAlarms } from './'
import { themedUseStyletron } from '../../../../theme/customTheme';
import OnboardingView from './Onboarding/OnboardingView';

export function OverviewPanel(props: TP_Building) {
    const [css, theme] = themedUseStyletron();
    const name = hasAddress(props.address) ? getAddress(props.address) : props.name;


    return (
        <OverviewPanelWrapper height={theme.appSizes.largeAppHeight} icon={<Icon type={props.buildingType} size='100%' color={theme.colors.backgroundPrimary}></Icon>} {...props} nameOverride={name}>
            {props.showLocation && <LocationView {...props} />}
            <ImportantAlarms {...props}></ImportantAlarms>
            {props.isOnboarding ?
                <OnboardingView showFinishButton={false} {...props}></OnboardingView>
                : <>
                    <ActiveAirHandlingUnits parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveAirHandlingUnits>
                    <ActiveHeatingGenerators parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingGenerators>
                    <ActiveHeatingOutlets parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingOutlets>
                    <ActiveCoolingGenerators parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveCoolingGenerators>
                    <ActiveCoolingOutlets parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveCoolingOutlets>
                    <ActiveHeatingPuffer parentId={props.id} parentResourceGroupId={props.resourceGroupId}></ActiveHeatingPuffer>
                    <ActiveLightsPanel parentId={props.id} resourceGroupId={props.resourceGroupId}></ActiveLightsPanel>

                    {props.showEOV && <EnergyOverview {...props} />}
                </>
            }

        </OverviewPanelWrapper >
    );
}



const EnergyOverview = (props: TP_Building) => {
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id, !props.showEOV)

    const eOV = useMemo(() => {
        return children?.find((v: any) => v.schema === evoSchema);
    }, [children])

    return (<LoadingView isLoading={isLoading && !eOV} error={error} isSucess={isSuccess || eOV}>
        {eOV &&
            <EnergyPanel {...eOV}></EnergyPanel>
        }
    </LoadingView>)
}





